import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createBlock(_component_Tag, {
    class: "price",
    "tag-style": _ctx.tagStyle,
    "small-tag": true
  }, {
    tagContent: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.paymentTotal), 1)
    ]),
    _: 1
  }, 8, ["tag-style"]))
}